import { Button } from "@/components/ui/button";
import { cn } from "@/lib/utils";
import { Check } from "lucide-react";
import type { Calendar } from "@/hooks/useCalendar";

interface CalendarFilterBarProps {
  calendars: Calendar[];
  selectedIds: string[];
  onToggle: (id: string) => void;
  onToggleAll: () => void;
}

export function CalendarFilterBar({
  calendars,
  selectedIds,
  onToggle,
  onToggleAll,
}: CalendarFilterBarProps) {
  const allSelected = calendars.length > 0 && selectedIds.length === calendars.length;
  const noneSelected = selectedIds.length === 0;

  if (calendars.length === 0) return null;

  return (
    <div className="flex flex-wrap items-center gap-2">
      {calendars.map((cal) => {
        const isSelected = selectedIds.includes(cal.id);
        return (
          <Button
            key={cal.id}
            variant="outline"
            size="sm"
            onClick={() => onToggle(cal.id)}
            className={cn(
              "h-7 rounded-full text-xs font-medium transition-all gap-1.5",
              isSelected
                ? "border-transparent text-white shadow-sm"
                : "opacity-60 hover:opacity-100"
            )}
            style={
              isSelected
                ? { backgroundColor: cal.color, borderColor: cal.color }
                : { borderColor: cal.color, color: cal.color }
            }
          >
            {isSelected && <Check className="h-3 w-3" />}
            {cal.name}
          </Button>
        );
      })}
      {!allSelected && !noneSelected && (
        <Button
          variant="ghost"
          size="sm"
          onClick={onToggleAll}
          className="h-7 text-xs text-muted-foreground"
        >
          Select All
        </Button>
      )}
      {allSelected && (
        <Button
          variant="ghost"
          size="sm"
          onClick={onToggleAll}
          className="h-7 text-xs text-muted-foreground"
        >
          Clear
        </Button>
      )}
    </div>
  );
}
